






import Vue from 'vue';
import ProductList from '@/components/ProductList.vue';

export default Vue.extend({
    name: 'ProductListView',
    components: {
        ProductList,
    },
});
